import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { getStyle } from '../../components';
import './Shop.less';
import { dateformat, push } from '../../utils';
import autobind from 'autobind-decorator';

interface NavPropType {
    prefixCls?: string;
    list: any; // 数据
    len?: any; // 商品为0
    pic?: any; // 总价
    isshop?: any;
    onQuan?: any; // 选择
    onJia?: any; // 加
    onJian?: any; // 减
    onDel?: any; // 删除
    index?: any;
    isEdit: boolean; // 是否是编辑
    onNumChange?: any; // 输入数量
    onNumBlur?: any;
    onNumFocus?: any;
    isChangeHeight?: any;
    skuIdsArr?: any;
}

@observer
class Wen extends React.Component<NavPropType, any> {
    public static defaultProps = {
        prefixCls: 'shop-list',
        isEdit: false,
    };

    public static contextTypes = {
        router: PropTypes.object
    };

    public constructor(props: NavPropType, context) {
        super(props, context);
        // this.state = {
        //     size: 1
        // };
    }

    public render(): React.ReactNode {
        const {prefixCls, list, onQuan, isEdit, onNumBlur, onNumFocus, isChangeHeight, onJia, onJian} = this.props;
        let data = list;
        const size = data.num ? String(data.num).length : 1;
        data.myPrice = data.cartPrice;
        Object.assign(data, list.skuItem);
        let style = getStyle(this.props);
        let isNoGoods: boolean = data.isOnline === false || data.inventory === 0 || data.isAddress === true; // 是否有货
        return (
            <div style={style} className={`${prefixCls} ` + (isNoGoods ? `${prefixCls}-no` : ``)}>
                <div
                    className={`${prefixCls}-checkedBox`}
                    onClick={() => {
                        onQuan(data);
                    }}
                >
                    <span
                        className={`${prefixCls}-checkedBox-img ${this._showSelectStatus(data.isEditQuan, data.isquan, isNoGoods, isEdit)}`}
                    />
                </div>
                <div className={`${prefixCls}-container clearfix`}>
                    <div className={`${prefixCls}-container-top clearfix`}>
                        <div
                            className={`${prefixCls}-image`}
                            onClick={() => {
                                this.onPush(isChangeHeight, data);
                            }}
                        >
                            <img src={data.images || data.mastermap} alt=""/>
                            {this._showStatusText(data)}
                        </div>
                        <div className={`${prefixCls}-context`}>
                            <p
                                className={`${prefixCls}-context-title`}
                                onClick={() => {
                                    this.onPush(isChangeHeight, data);
                                }}
                            >
                                {data.name}
                            </p>
                            <p className={`${prefixCls}-context-props`}>{data.skuJson && data.skuJson.replace(/\s+/g, '，')}</p>
                            <div className={`${prefixCls}-context-tool clearfix`}>
                                <span
                                    className={`${prefixCls}-context-price`}
                                >
                                    ￥{data.cartPrice && data.cartPrice.toFixed(2)}
                                </span>
                                <div className={`${prefixCls}-context-input`}>
                                    <span
                                        className={`${prefixCls}-context-reduce`}
                                        onClick={() => {
                                            isNoGoods ? null : onJian(data, data);
                                        }}
                                        style={this._showReduceStatus(data) ? {
                                            borderLeft: '0.05rem solid #CDCDCD',
                                            borderTop: '0.05rem solid #CDCDCD',
                                            borderBottom: '0.05rem solid #CDCDCD',
                                        } : {}}
                                    >
                                        <img
                                            src={this._showReduceStatus(data) ? require('../../images/shop_reduce_gray.png') : require('../../images/shop_reduce.png')}
                                            alt=""
                                        />
                                    </span>
                                    <input
                                        type="text"
                                        disabled={isNoGoods}
                                        value={data.num}
                                        onChange={(val) => {
                                            this.onNumChange(data, val);
                                        }}
                                        onBlur={
                                            () => onNumBlur(data, data)
                                        }
                                        onFocus={
                                            () => onNumFocus(data)
                                        }
                                        size={size}
                                    />
                                    <span
                                        className={`${prefixCls}-context-add`}
                                        onClick={() => {
                                            isNoGoods ? null : onJia(data, data);
                                        }}
                                        style={this._showAddStatus(data) ? {
                                            borderRight: '0.05rem solid #CDCDCD',
                                            borderTop: '0.05rem solid #CDCDCD',
                                            borderBottom: '0.05rem solid #CDCDCD',
                                        } : {}}
                                    >
                                        <img
                                            src={this._showAddStatus(data) ? require('../../images/shop_add_gray.png') : require('../../images/shop_add.png')}
                                            alt=""
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${prefixCls}-activity clearfix`}>
                        {
                            this._showText(data) !== '' && (data.inventory !== 0 && data.isOnline !== false) &&
                            <span>
                                {dateformat(this._showStatusTime(data) / 1000, 'mm月dd日 HH:MM:ss')} {this._showText(data)}
                            </span>
                        }
                        {data.limitNum !== 0 && <span>{this._showInventoryStatus(data)}</span>}
                    </div>
                </div>
            </div>
        );
    }

    // 显示复选框选种样式
    private _showSelectStatus(isEditQuan: boolean, isquan: boolean, isNoGoods: boolean, isEdit: boolean): string {
        let str = '';
        if (!isNoGoods) {
            if (isquan && !isEdit) {
                str = 'select';
            } else if (isEditQuan && isEdit) {
                str = 'select';
            } else {
                str = 'select_no';
            }
        } else {
            str = 'select_disable';
        }
        return str;
    }

    // 数量是否可减
    private _showReduceStatus(data: any): boolean {
        return (data.inventory === 0 || data.num <= 1 || data.isOnline === false || data.isAddress === true);
    }

    // 数量是否可加
    private _showAddStatus(data: any): boolean {
        if (data.isPromotion === 1) {
            if (data.limitNum !== 0) {
                return (data.inventory === 0 || data.num >= data.limitNum || data.isOnline === false || data.isAddress === true);
            } else {
                return (data.inventory === 0 || data.isOnline === false || data.isAddress === true);
            }
        } else {
            return (data.inventory === 0 || data.num === data.inventory || data.isOnline === false || data.isAddress === true);
        }
    }

    @autobind
    onNumChange(data: any, val: any) {
        const {onNumChange} = this.props;
        if (onNumChange) {
            // this.setState({
            //     size: val.target.value.length
            // });
            if (val.target.value.length <= 4) {
                onNumChange(data, val.target.value);
            }
        }
    }

    // 显示库存状态
    @autobind
    private _showInventoryStatus(data: any): string {
        if (data.num > data.inventory) {
            return '库存不足';
        } else if (data.inventory < 5) {
            return '库存紧张';
        } else if (data.limitType === 0) {
            return `每人限购${data.limitNum}件`;
        } else if (data.limitType === 1) {
            return `每人每天限购${data.limitNum}件`;
        } else {
            return '';
        }
    }

    @autobind
    private _showStatusText(data: any): any {
        if (data.isOnline === false) {
            return <div><span>已下架</span></div>;
        } else if (data.inventory === 0) {
            return <div><span>已抢光</span></div>;
        } else if (data.isAddress) {
            return <div><span>暂不配送</span></div>;
        } else {
            return null;
        }
    }

    // 显示状态
    @autobind
    private _showText(data): string {
        if (data.isPromotion === 1) {
            return '恢复原价';
        } else if (data.isPromotion === 2) {
            if (data.isForbid === 1) {
                return '开始售卖';
            }
        }
        return '';
    }

    // 时间
    @autobind
    private _showStatusTime(data: any): any {
        if (data.isPromotion === 1) {
            return data.endTime;
        } else if (data.isPromotion === 2) {
            if (data.isForbid === 1) {
                return data.startTime;
            }
        }
        return null;
    }

    // 跳转详情
    @autobind
    private onPush(isChangeHeight: boolean, data: any): void {
        if (!isChangeHeight && data.isOnline && !data.isAddress) {
            push('/appdetail/' + data.productId, this);
        }
    }
}

export default Wen;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/common/ShopList.tsx